<script setup lang="ts">
import type { CmsElementSidebarFilter } from "@shopware/composables";
import SwProductListingFilters from "~/components/cms/SwProductListingFilters.vue";

const props = defineProps<{
  content: CmsElementSidebarFilter;
  class: any;
  style: any;
}>();
</script>
<template>
  <div class="container" :style="props.style" :class="props.class">
    <div class="row">
      <div class="col-lg-12 order-lg-1">
        <div class="filters section__filters">
          <SwProductListingFilters :content="content" />
        </div>
      </div>
    </div>
  </div>
</template>
